export const RESELLERS_PATH = '/resellers'

export const resellerPath = id => `${RESELLERS_PATH}/${id}`

export const resellerName = reseller => reseller.attributes.display_name || `Reseller #${reseller.id}`

// One page: the overview chart with the resellers table under it. It stays
// lit on each reseller's own page, active or deactivated, on any tab.
export default {
  bases: [RESELLERS_PATH],
  fetches: ['resellers?included=none'],
  build: ({ mapTypeIncludingInactive }) => [
    {
      name: 'Overview',
      link: RESELLERS_PATH,
      match: [RESELLERS_PATH, ...mapTypeIncludingInactive('reseller').map(reseller => resellerPath(reseller.id))]
    }
  ]
}
